export interface NativeContentBlock { kind: 'thinking' | 'text'; text: string; index?: number }

export interface NativeEvent { kind: string; text?: string; message?: string; message_id?: string; tool?: string; activity?: string; state?: string; session_id?: string | null; turn_id?: string; event_index?: number; generation?: number; phase?: string; sequence?: number; usage?: Record<string, unknown>; model?: string; total_cost_usd?: number; api_error_status?: number; ok?: boolean; stream_event_type?: string; stream_message_id?: string; block_index?: number; block_type?: string; content_blocks?: NativeContentBlock[] }

export async function readSse(response: Response, onEvent: (event: NativeEvent) => void): Promise<void> {
  if (!response.body) throw new Error('streaming response body is unavailable')
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  while (true) {
    const { value, done } = await reader.read()
    buffer += decoder.decode(value, { stream: !done })
    let boundary = buffer.indexOf('\n\n')
    while (boundary >= 0) {
      const frame = buffer.slice(0, boundary)
      buffer = buffer.slice(boundary + 2)
      const data = frame.split('\n').filter((line) => line.startsWith('data:')).map((line) => line.slice(5).trimStart()).join('\n')
      if (data) onEvent(JSON.parse(data) as NativeEvent)
      boundary = buffer.indexOf('\n\n')
    }
    if (done) break
  }
  if (buffer.trim()) throw new Error('native event stream ended with a partial frame')
}
